import type { PaymentIssue } from "./useTrial"

export const formatPaymentAmount = (amountInCents: number, currency: string) =>
	new Intl.NumberFormat(undefined, {
		style: "currency",
		currency: currency.toUpperCase(),
		minimumFractionDigits: amountInCents % 100 === 0 ? 0 : 2,
	}).format(amountInCents / 100)

export const formatRetryDate = (iso: string) =>
	new Date(iso).toLocaleDateString(undefined, {
		month: "short",
		day: "numeric",
	})

export interface PaymentIssueCopy {
	header: string
	body: string
	short: string
}

export const paymentIssueCopy = (issue: PaymentIssue): PaymentIssueCopy => {
	const amount =
		issue.amountDue != null && issue.currency
			? formatPaymentAmount(issue.amountDue, issue.currency)
			: null

	const header =
		issue.status === "incomplete"
			? "Your first payment needs a working card"
			: "Update your payment method"

	const invoice = amount ? `The ${amount} invoice` : "Your latest invoice"

	const retry = issue.nextPaymentAttempt
		? ` We retry the charge on ${formatRetryDate(issue.nextPaymentAttempt)}.`
		: ""

	const consequence =
		issue.status === "unpaid"
			? " Settle it to keep your plan."
			: " Your workspace keeps running while it is open."

	return {
		header,
		body: `The card on file was declined. ${invoice} is still open.${retry}${consequence}`,
		short: amount ? `${amount} payment declined` : "Payment declined",
	}
}
